import MasterCrudPage from "../../components/MasterCrudPage";
import {
  kycMasterApi,
  userKycApi,
  userMasterApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function UserKyc() {
  return (
    <MasterCrudPage
      title="User KYC"
      description="User KYC documents with front/back images and verification details."
      idKey="user_kyc_id"
      api={userKycApi}
      listLabel="user KYC records"
      loadExtraOptions={async () => {
        const [users, kycTypes] = await Promise.all([
          userMasterApi.list(),
          kycMasterApi.list(),
        ]);
        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
          kycTypes: (kycTypes || []).map((type) => ({
            value: type.kyc_id,
            label: type.kyc_field,
          })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "kyc_id",
          label: "User KYC",
          type: "select",
          required: true,
          optionsKey: "kycTypes",
          placeholder: "Select KYC type",
        },
        {
          name: "user_kyc_value",
          label: "User KYC Value",
          type: "text",
          required: true,
          placeholder: "Document number / value",
        },
        {
          name: "front_page_image",
          label: "Upload Front Page Image",
          type: "image",
        },
        {
          name: "back_page_image",
          label: "Upload Back Page Image",
          type: "image",
        },
        {
          name: "kyc_verified",
          label: "User KYC Verified",
          type: "checkbox",
          defaultValue: false,
          checkLabel: "Yes",
        },
        {
          name: "kyc_verification_by",
          label: "User KYC Verification By",
          type: "text",
          placeholder: "Verifier name",
        },
        {
          name: "kyc_verification_date",
          label: "User KYC Verification Date",
          type: "date",
        },
        {
          name: "kyc_verification_certificate",
          label: "User KYC Verification Certificate",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
        },
      ]}
      columns={[
        { key: "user_kyc_id", label: "ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.user_id, item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        { key: "kyc_field", label: "KYC Type" },
        { key: "user_kyc_value", label: "KYC Value" },
        { key: "front_page_image", label: "Front", type: "image" },
        { key: "back_page_image", label: "Back", type: "image" },
        { key: "kyc_verified", label: "Verified", type: "status" },
        { key: "kyc_verification_by", label: "Verified By" },
        { key: "kyc_verification_date", label: "Verified Date" },
      ]}
    />
  );
}
